module.exports = __webpack_public_path__ + "static/media/ST_LogoMaster 1.d31e619b.png";